import React from 'react';
import PropTypes from 'prop-types';
import { noop, get } from 'lodash';

import {
    Grid,
    MuiButton,
    Box,
    CircularProgress,
} from '../../../components/mui';
import Form from '../../../components/Form';
import { messages as commonMessages } from '../../constants';
import {
    messages as imageMessages,
    validators as imageValidators,
} from '../../images/constants';

const { msgRequired, msgSave, msgCancel } = commonMessages;
const { msgInvalidUniqueImageName } = imageMessages;
const { isUniqueImageName } = imageValidators;

const SaveVmImageForm = ({ selectedItem, images, onSubmit, onClose }) => {
    const handleValidate = (values) => {
        const errors = {};

        if (!values.newName) {
            errors.newName = msgRequired;
        } else if (!isUniqueImageName(values.newName, images)) {
            errors.newName = msgInvalidUniqueImageName;
        }

        return errors;
    };

    const handleCancel = () => {
        onClose();
    };

    const handleSubmit = async (values) => {
        await onSubmit(values);
    };

    const fields = [
        {
            name: 'baseImage',
            label: 'Current Image Name',
            initialValue: get(selectedItem, 'image', ''),
            InputProps: {
                inputProps: {
                    readOnly: true,
                },
            },
        },
        {
            name: 'newName',
            label: 'New Image Name *',
            initialValue: '',
        },
    ];

    const formContentRenderer = ({ isSubmitting }) => (
        <Box mt={2} mb={1}>
            <Grid container alignItems="center">
                <Grid item xs>
                    {isSubmitting && (
                        <Box data-testid="loading">
                            <CircularProgress size="1.5rem" />
                        </Box>
                    )}
                </Grid>
                <Grid item>
                    <MuiButton
                        data-testid="cancel"
                        onClick={handleCancel}
                        disabled={isSubmitting}
                    >
                        {msgCancel}
                    </MuiButton>
                    <MuiButton
                        data-testid="submit"
                        type="submit"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        {msgSave}
                    </MuiButton>
                </Grid>
            </Grid>
        </Box>
    );

    return (
        <Form
            fields={fields}
            onValidate={handleValidate}
            onSubmit={handleSubmit}
            formContentRenderer={formContentRenderer}
        />
    );
};

SaveVmImageForm.propTypes = {
    selectedItem: PropTypes.object,
    images: PropTypes.arrayOf(PropTypes.string),
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

SaveVmImageForm.defaultProps = {
    selectedItem: null,
    images: [],
    onSubmit: noop,
    onClose: noop,
};

export default SaveVmImageForm;
